export const DefaultErrorMessage = {
  msg: 'Server error. Please try again!'
};